import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import paywallsActions from 'redux/actions/paywallsActions'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'
import View from 'views/paywalls/confirms/google_slides_unauthorized_edit_view'

class GoogleSlidesUnauthorizedEditContainer extends PureComponent {

	learnMore = () => {
		this.props.actions.learnMore(this.props.upgradeSource)
	}

	editInNearpod = () => {
		this.props.actions.editGoogleSlidesInNearpod(this.props.lessonData)
	}

	render() {
		return (
			<View
				handleEditInNearpod={this.editInNearpod}
				handleLearnMore={this.learnMore}
				handleCloseConfirm={this.props.actions.closeConfirmSelected}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		editGoogleSlidesInNearpod: myLibraryActions.editGoogleSlidesInNearpod,
		learnMore: paywallsActions.googleSlidesEditAsUnauthorized,
		closeConfirmSelected: paywallsActions.googleSlidesUnauthorizedEditClose,
	}, dispatch)
}

GoogleSlidesUnauthorizedEditContainer.propTypes = {
	actions: PropTypes.shape({
		editGoogleSlidesInNearpod: PropTypes.func.isRequired,
		learnMore: PropTypes.func.isRequired,
		closeConfirmSelected: PropTypes.func.isRequired,
	}),
	upgradeSource: PropTypes.oneOf(
		Object.values(upgradeSourceTypes)
	).isRequired,
	lessonData: PropTypes.object.isRequired,
}

export default connect(null, mapDispatchToProps)(
	GoogleSlidesUnauthorizedEditContainer
)

export { GoogleSlidesUnauthorizedEditContainer }
